import React from 'react'
import { ListPageLayout } from '@/components/ListPageLayout'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'

export type ListPageLayoutBlockProps = {
  title: string
  description?: string | null
  items?: Block[] | null
  emptyState?: Block[] | null
  blockType: 'listPageLayout'
}

export const ListPageLayoutBlock: React.FC<ListPageLayoutBlockProps> = ({
  title,
  description,
  items,
  emptyState,
}) => {
  const isEmpty = !items || items.length === 0
  return (
    <ListPageLayout
      title={title}
      description={description || undefined}
      isEmpty={isEmpty}
      emptyState={isEmpty ? <RenderBlocks blocks={emptyState ?? []} /> : undefined}
    >
      <RenderBlocks blocks={items ?? []} />
    </ListPageLayout>
  )
}
